<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <div class="col-md-12">
        <h6 class="admintitle">
          {{lang.Invoices}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
        </h6>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-md-4">
        <label for="memberType">Select Member<span
          class="text-danger">*</span></label>
        <select
          class="form-control1"
          id="gender"
          placeholder="Select"
          (change)="memeberdetails($event)"
          #brokerstatus
        >
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let memebr of members" [value]="memebr.id">
            {{ memebr.firstName | titlecase }} {{ memebr.lastName | titlecase }}
          </option>
        </select>
      </div>
    </div> -->




    <div class="mt-2 form-container linescrollbar p-2">
      <form [formGroup]="filterForm" class="row">
        <div class="col-md-5 d-flex gap-3">
          <div class="form-check mt-2">
            <input class="form-check-input" type="checkbox" id="monthRangeToggle" formControlName="monthRangeEnabled"
              (change)="toggleMonthRange()">
            <label class="form-check-label" for="monthRangeToggle">{{lang.Month_Range_Selection}}</label>
          </div>

          <div class="form-group" *ngIf="filterForm.get('monthRangeEnabled').value">
            <input type="text" style="width:250px;border: 1px solid grey !important;" formControlName="dateSelection"
              class="form-control" placeholder="Select Month" bsDaterangepicker [minDate]="minDateForPicker"
              [maxDate]="maxDateForPicker" [bsConfig]="{ rangeInputFormat: 'MMM YYYY', minMode: 'month' }">
          </div>
          <div class="form-group" *ngIf="!filterForm.get('monthRangeEnabled').value">
            <input type="text" style="width:250px;border: 1px solid grey !important;" formControlName="dateSelection"
              class="form-control" placeholder="Select Month" bsDatepicker [minDate]="minDateForPicker"
              [maxDate]="maxDateForPicker" [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month' ,showWeekNumbers: false }">
          </div>
          
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <select style="border: 1px solid grey !important;" class="form-control1 mt-2 select-style"
              placeholder="Select Category" formControlName="planCategory">
              <option value="" disabled>{{lang.Select}}</option>
              <option *ngFor="let pl of planCategories" [value]="pl.name">
                {{ pl.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <select style="border: 1px solid grey !important;" class="form-control1 mt-2 ms-2 select-style"
              placeholder="Select Category" formControlName="invoiceCategory">
              <option value="" disabled>Select</option>
              <option *ngFor="let ct of invoiceCategories" [value]="ct">
                {{ ct }}
              </option>
            </select>
          </div>


        </div>
        <!-- <div class="col-md-3">
          <div class="form-group">
            <select style="border: 1px solid grey !important;" class="form-control1 mt-2 ms-2 select-style"
              placeholder="Select Category" formControlName="invoiceCategory">
              <option value="" disabled>Select</option>
              <option *ngFor="let ct of paymentCategories" [value]="ct">
                {{ ct }}
              </option>
            </select>
          </div>


        </div>
        <div class="col-md-3">
          <div class="form-group">
            <select style="border: 1px solid grey !important;" class="form-control1 mt-2 ms-2 select-style"
              placeholder="Select Category" formControlName="invoiceCategory">
              <option value="" disabled>Select</option>
              <option *ngFor="let ct of stausCategories" [value]="ct">
                {{ ct }}
              </option>
            </select>
          </div>


        </div> -->
        <div class="col-md-12 mt-2 d-flex justify-content-end gap-1" style="font-size:12px">
          <button class="btn btn-primary" style="font-size:12px" (click)="applyFilters()">{{lang.Apply_Filters}}</button>
          <button class="btn btn-primary" style="font-size:12px" (click)="resetFilters()">{{lang.Reset_Filters}}</button>
        </div>

        <div class="col-md-6 row mt-2 linescrollbar" style="height:250px;overflow-y: auto;"
          *ngIf="this.members && this.members.length>0">
          <div class="form-group col-9">
            <label for="multiSelectMembers" class="form-check-label">{{lang.Select_Invoice}}</label>
            <ng-multiselect-dropdown #multiSelectDropdown [placeholder]="'Select'" class="linescrollbar"
              [settings]="dropdownSettings" [data]="members" (onSelect)="memberSelect($event)"
              (onSelectAll)="membersSelectAll($event)" (onDeSelect)="memberDeSelect($event)"
              (onDeSelectAll)="memberDeSelectAll($event)">
              >
            </ng-multiselect-dropdown>

          </div>
          <div class="mt-4 col-3">
            <button class="btn btn-primary" style="font-size:12px" (click)="getInvoices()">Get Invoices</button>
          </div>
          <div class="col-12 mt-4" *ngIf="showtabledata">
            <table datatable id="dataTableId" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" style="width:100%">
              <tr>
                <!-- <th style="width:10%">S.no</th> -->
                <th style="width:40%">{{lang.Month}}</th>
                <th style="width:30%">{{lang.Actions}}</th>
                <th style="width:20%">{{lang.Status}}</th>
              </tr>
              <tr>
                <!-- <td>1</td> -->
                <td>{{ getCustomerDraftDate }}({{this.lang.Draft}})</td>
                <td>
                  <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" id="viewing"
                    role="button" data-bs-toggle="tooltip" data-bs-placement="top" (click)="showdraftinvoice()"
                    title="View" />
                </td>
                <td></td>
              </tr>
              <tr *ngFor="let invoice of customerInvoices; let i = index">
                <td>
                  {{ i + 2 }}
                </td>
                <td>
                  {{
                  invoice.dueDate
                  | date
                  : "MMM yyyy"
                  }}
                </td>
                <td>
                  <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" id="viewing"
                    role="button" data-bs-toggle="modal" data-bs-placement="top" title="View"
                    (click)="viewinvoices(invoice.file)" />&nbsp;
                  <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing" role="button"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                    (click)="downloadinvoices(invoice)" height="20px" />
                </td>
                <td>{{invoice.status}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 border mt-2 " *ngIf="viewInvoice||viewDraftInvoice">
          <div *ngIf="viewInvoice">
            <span *ngIf="showViewPlansLoading">
              <img src="../../../assets/img/tenor.gif" width="100" style=" display: block;
                          margin-left: auto;
                          margin-right: auto;
                          width: 25%;">
            </span>
            <div>
              <pdf-viewer *ngIf="true" class="linescrollbar" [src]="invoiceslink" id="pdf-viewer"
                (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
            </div>
          </div>
          <div class="linescrollbar" *ngIf="viewDraftInvoice" style="
                    margin-top: 20px;
                    padding-right: 15px;
                    padding-left: 15px;
                    overflow: scroll;
                  ">
            <div [innerHTML]="getCustomerDraftDetails"></div>
          </div>
        </div>

      </form>

    </div>
  </section>
</main>

<div class="modal" id="viewinvoiceDraft" data-bs-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header text-light">
        <span class="modal-title">{{lang.View_Draft_Invoice}}</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="modal-body" style="
          margin-top: 20px;
          padding-right: 15px;
          padding-left: 15px;
          overflow: scroll;
        ">
        <div [innerHTML]="getCustomerDraftDetails"></div>
      </div>
      <div class="modal-footer py-2">
        <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="viewinvoice" data-bs-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header text-light">
        <span class="modal-title">{{lang.View_Invoice}}</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="modal-body" style="overflow-y: unset;">


        <div>
          <span *ngIf="showViewPlansLoading">
            <img src="../../../assets/img/tenor.gif" width="100" style=" display: block;
                margin-left: auto;
                margin-right: auto;
                width: 25%;">
          </span>
          <div>
            <pdf-viewer *ngIf="true" [src]="invoiceslink" id="pdf-viewer"
              (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
          </div>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
          id="cancelButton"><b>{{lang.Close}}</b></button>
      </div>
    </div>
  </div>
</div>
<a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i
    class="bi bi-arrow-up-short"></i></a>
